module.exports = __webpack_public_path__ + "media/theme/border-12-3adbf999.png";